export const setCookie = (key_value, value, days = 1) => {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = key_value + "=" + encodeURIComponent(value) + expires + "; path=/";
};

export const getCookie = (key_value) => {
    const cookies = document.cookie.split(";");
    for (let cookie of cookies) {
        const [key, val] = cookie.trim().split("=");
        if (key === key_value) {
            return decodeURIComponent(val);
        }
    }
    return null;
};

export const deleteCookie = (key) => {
    document.cookie = key + "=; Max-Age=0; path=/";
};
